module.exports = __webpack_public_path__ + "static/media/fuel-filter-change.3595841a.svg";